'use es6';

import { css } from 'styled-components';
export const breakpointValues = {
  hd: 1920,
  mon569: 1700,
  sd: 1366,
  cs: 1190,
  tablet: 1024,
  mon569Height: 900,
  tabletPortrait: 800,
  phoneLarge: 680,
  phone: 500,
  mon491: 960
};
export const minWidthBreakpoint = Object.keys(breakpointValues).reduce((acc, label) => {
  acc[label] = (...args) => css(["@media (min-width:", "em){", "}"], (breakpointValues[label] + 1) / 16, css(...args));

  return acc;
}, {});
export const minHeightBreakpoint = Object.keys(breakpointValues).reduce((acc, label) => {
  acc[label] = (...args) => css(["@media (min-height:", "em){", "}"], breakpointValues[label] / 16, css(...args));

  return acc;
}, {});
export const maxHeightBreakpoint = Object.keys(breakpointValues).reduce((acc, label) => {
  acc[label] = (...args) => css(["@media (max-height:", "em){", "}"], breakpointValues[label] / 16, css(...args));

  return acc;
}, {});
export default Object.keys(breakpointValues).reduce((acc, label) => {
  acc[label] = (...args) => css(["@media (max-width:", "em){", "}"], breakpointValues[label] / 16, css(...args));

  return acc;
}, {});